import { RECIPE_FEEDBACK_ENDPOINTS } from "./endpoints";
import type { RecipeFeedbackPayload, RecipeFeedbackReceipt } from "./types";
import { apiRequestWithData } from "../shared";

/**
 * Sends one recipe refresh/delete feedback event.
 *
 * Callers treat this as fire-and-forget: the menu has already been mutated
 * client-side and must never be rolled back because this write failed.
 */
export default async function recordRecipeFeedback(
  payload: RecipeFeedbackPayload,
): Promise<RecipeFeedbackReceipt> {
  return apiRequestWithData<RecipeFeedbackReceipt>(RECIPE_FEEDBACK_ENDPOINTS.RECORD, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
